module.exports = __webpack_public_path__ + "media/agora-end-call.5e1f1ddf.wav";